import { render } from "./P050.vue?vue&type=template&id=1e0c24e6&scoped=true"
import script from "./P050.vue?vue&type=script&lang=js"
export * from "./P050.vue?vue&type=script&lang=js"

import "./P050.vue?vue&type=style&index=0&id=1e0c24e6&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0c24e6"]])

export default __exports__